import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b4008e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6b4008e2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4008e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4008e2')) {
      api.createRecord('6b4008e2', component.options)
    } else {
      api.reload('6b4008e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b4008e2&scoped=true", function () {
      api.rerender('6b4008e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/PsychologyTeaCampus/components/PsyCampusMood/index.vue"
export default component.exports